import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Signin from "../signin/Signin";
import { logout } from "../../api/Api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link as ScrollLink } from "react-scroll";
import settings from "../../assets/img/settings.png";

const Navbar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false); // State for loading
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("pd");
    setIsUserLoggedIn(!!storedUser);
  }, []);

  // const handleLogout = () => {
  //   setIsClicked(true); // Set clicked state to true when logout is clicked
  //   // Call your logout logic here
  // };
  const handleLogout = async () => {
    setLoading(true); // Start loading
    setIsClicked(true);
    try {
      const data = localStorage.getItem("pd");
      if (data) {
        const { email } = JSON.parse(data).user;
        const response = await logout(email);

        if (response.status === 200 || response.success) {
          localStorage.removeItem("pd");
          localStorage.removeItem("AllOrders");
          localStorage.removeItem("orders");
          localStorage.removeItem("todayOrders");
          localStorage.removeItem("todaysOrders");
          localStorage.removeItem("totalOrders");
          localStorage.removeItem("monthlyOrders");
          
          navigate("/LogoutDashboard");
        } else {
          throw new Error("Failed to logout.");
        }
      }
    } catch (error) {
      navigate("/ErrorDashboard");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const menuItems = [
    { name: "Home", target: "home-section" },
    { name: "Services", target: "services-section" },
    { name: "About Us", target: "about-section" },
  ];

  return (
    <>
      <AppBar
        position="static"
        sx={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Toolbar
          sx={{
            justifyContent: { md: "space-between", xs: "space-between" },
            px: { xs: 1, md: 2 },
            py: { xs: 1, md: 2 },
            width: "86%",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "start",
              justifyContent: "flex-start",
              width: "20%",
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                color: theme.palette.primary.light,
                fontSize: { xs: "1.4rem", md: "2rem" },
                fontFamily: theme.typography.fontFamily,
                fontWeight: "600",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              Drips Water
              {/* Adi Aqua Ltd. */}
            </Typography>
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "space-around",
              gap: "1vw",
              marginRight: "6vw",
            }}
          >
            {menuItems.map((item) => (
              <ScrollLink
                key={item.name}
                to={item.target}
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-70}
              >
                <Button
                  color="inherit"
                  sx={{
                    color: theme.palette.primary.light,
                    ml: 1,
                    textTransform: "capitalize",
                    fontSize: "1.1rem",
                  }}
                >
                  {item.name}
                </Button>
              </ScrollLink>
            ))}

            {isUserLoggedIn && (
              <Button
                color="inherit"
                onClick={() => navigate("/dashboard")}
                sx={{
                  color: theme.palette.primary.light,
                  ml: 1,
                  textTransform: "capitalize",
                  fontSize: "1.1rem",
                }}
              >
                Dashboard
              </Button>
            )}

            <Box sx={{ ml: 6 }}>
              {isUserLoggedIn ? (
                <Button
                  variant="contained"
                  onClick={handleLogout}
                  sx={{
                    mb: 2,
                    margin: "auto",
                    width: "8vw",
                    display: "block",
                    padding: "10px",
                    backgroundColor: isClicked ? "#114C78" : "#114C78",
                    borderRadius: "20px",
                    color: isClicked ? "#000" : "#fff",
                    textTransform: "capitalize", 
                  }}
                  disabled={loading} 
                >
                  {loading ? (
                   <Box
                   sx={{
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     gap: "0.5rem",
                     color: "#fff", // Sets text color to white
                   }}
                 >
                   Processing
                   <img
                     src={settings}
                     alt="Loading"
                     style={{
                       width: "18px", // Smaller icon size
                       height: "18px",
                       animation: "rotate 3s linear infinite", // Slower rotation
                       filter: "invert(1)", // Changes icon color to white
                     }}
                   />
                 </Box>
                 
                  ) : (
                    "Logout"
                  )}
                </Button>
              ) : (
                <Signin />
              )}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <ToastContainer />
    </>
  );
};

export default Navbar;
